import React from 'react';
import { useTranslation } from "react-i18next";
import { AddressTypeEnum, FacilityTypeEnum } from "../../common/enums";
import ItemLabel from "../ItemLabel/ItemLabel";
import Panel from "../Panel/Panel";
import { Divider, List, ListItem, Stack, Typography } from "@mui/material";

const AddressPanel = ({ address, addresses, addressNotes, renderAction, renderExtra, ...panelProps }) => {
  const { t } = useTranslation();
  const items = addresses ?? (address ? [address] : []);

  return (
    <Panel title={t("PatientsDetails.addresses")} variant="outlined" {...panelProps}>
      {items.map((addr, index) => {
        const fields = [
          addr?.address_type && { label: t("PatientsDetails.addressType"), text: AddressTypeEnum[addr.address_type] ?? FacilityTypeEnum[addr.address_type] },
          addr?.facility_type && { label: t("PatientsDetails.facilityType"), text: FacilityTypeEnum[addr.facility_type] },
          (addr?.facility_name || addr?.location_name) && { label: t("PatientsDetails.facilityName"), text: addr.facility_name ?? addr.location_name },

          addr?.room_number && { label: t("PatientsDetails.room"), text: addr.room_number },
          addr?.bed_number && { label: t("PatientsDetails.bed"), text: addr.bed_number },
          (addr?.address_notes || (index === 0 && addressNotes)) && { label: t("PatientsDetails.addressNotes"), text: addr?.address_notes ?? addressNotes },
        ].filter(Boolean);

        return (
          <React.Fragment key={addr.address_id ?? index}>
            {index > 0 && <Divider />}
            <List disablePadding>
              <ListItem key={index} disablePadding sx={{ justifyContent: 'space-between', alignItems: 'flex-end' }}>
                <Stack sx={{ pt: index === 0 ? 0 : 3, pb: index === items.length - 1 ? 0 : 3 }}>
                  {fields.map(({ label, text }) => (
                    <ItemLabel key={label} label={label} text={text} />
                  ))}
                  {addr?.address_line1 && (
                    <Typography sx={{ mt: 2 }}>
                      {addr.address_line1}<br />
                      {addr.address_line2 && <>{addr.address_line2}<br /></>}
                      {[addr.city, addr.state, addr.zip_code, addr.country].filter(Boolean).join(', ')}
                    </Typography>
                  )}
                </Stack>
                {renderAction?.(addr, index)}
              </ListItem>
              {renderExtra && (
                <ListItem disablePadding>
                  {renderExtra(addr, index)}
                </ListItem>
              )}
            </List>
          </React.Fragment>
        );
      })}
    </Panel>
  );
};

export default AddressPanel;
